import { Link, useRouteError, isRouteErrorResponse } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'
import { ROUTES } from '@/config/routes'
import { AlertCircle, Home, ArrowLeft } from 'lucide-react'

export const ErrorPage = () => {
  const error = useRouteError()
  let errorMessage = 'An unexpected error has occurred'
  let errorStatus = 'Error'

  if (isRouteErrorResponse(error)) {
    errorStatus = `${error.status}`
    errorMessage = error.statusText || error.data?.message || errorMessage
  } else if (error instanceof Error) {
    errorMessage = error.message
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <Card className="max-w-lg w-full">
        <CardHeader>
          <div className="flex items-center gap-2">
            <AlertCircle className="h-6 w-6 text-destructive" />
            <CardTitle className="text-2xl">{errorStatus}</CardTitle>
          </div>
          <CardDescription>Something went wrong</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="rounded-md bg-destructive/10 p-4 text-sm text-destructive">
            {errorMessage}
          </div>
          <p className="mt-4 text-sm text-muted-foreground">
            We're sorry for the inconvenience. If this problem persists, please contact support.
          </p>
        </CardContent>
        <CardFooter className="flex gap-2">
          <Button asChild>
            <Link to={ROUTES.DASHBOARD}>
              <Home className="mr-2 h-4 w-4" />
              Go to Dashboard
            </Link>
          </Button>
          <Button asChild variant="outline" onClick={() => window.history.back()}>
            <span>
              <ArrowLeft className="mr-2 h-4 w-4" />
              Go Back
            </span>
          </Button>
        </CardFooter>
      </Card>
    </div>
  )
}
